import React from 'react';

export default function PatientStudies() {
  return <>Patient studies</>;
}
